export function compareDisplays(left, right, now = Date.now()) {
  const group = item => ["in_progress", "active"].includes(item.status) ? 0
    : !Number.isFinite(item.sortValue) ? 3 : (item.upcoming ?? item.sortValue >= now) ? 1 : 2;
  const order = group(left) - group(right);
  if (order) return order;
  const dateOrder = group(left) === 1 ? left.sortValue - right.sortValue : right.sortValue - left.sortValue;
  return (Number.isFinite(dateOrder) ? dateOrder : 0) || left.title.localeCompare(right.title);
}
